// extracted by mini-css-extract-plugin
module.exports = {"created":"_09Ob","visible":"_8k2p","alt":"PMWz"};